import { CannedResponse } from '../types/cannedResponse';

const now = new Date().toISOString();

/** Seed data: English + Arabic bodies and separate shortcuts per language */
export const defaultCannedResponses: CannedResponse[] = [
  {
    id: '1',
    title: 'Greeting - Welcome',
    titleAr: 'ترحيب',
    content: 'Hello! Thank you for contacting our support team. How may I assist you today?',
    contentAr: 'مرحباً! شكراً لتواصلك مع فريق الدعم. كيف يمكنني مساعدتك اليوم؟',
    category: 'greeting',
    tags: ['welcome', 'greeting', 'hello'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/greet',
    shortcutAr: '/greet_ar',
    usageCount: 45,
  },
  {
    id: '2',
    title: 'Closing - Thank You',
    titleAr: 'ختام وشكر',
    content:
      'Thank you for reaching out! If you have any other questions, feel free to ask. Have a great day!',
    contentAr:
      'شكراً لتواصلك! إذا كان لديك أي استفسار آخر، لا تتردد في السؤال. أتمنى لك يوماً سعيداً!',
    category: 'closing',
    tags: ['closing', 'thank you', 'goodbye'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/thanks',
    shortcutAr: '/thanks_ar',
    usageCount: 32,
  },
  {
    id: '3',
    title: 'Escalation Notice',
    titleAr: 'تصعيد التذكرة',
    content:
      "I'm escalating your ticket to our senior support team. They will review your case and get back to you within 24 hours. Your ticket reference is: {{ticketId}}",
    contentAr:
      'أقوم بتحويل تذكرتك إلى فريق الدعم الأقدم. سيراجعون حالتك ويعودون إليك خلال 24 ساعة. مرجع تذكرتك: {{ticketId}}',
    category: 'escalation',
    tags: ['escalate', 'senior', 'priority'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/escalate',
    shortcutAr: '/escalate_ar',
    usageCount: 18,
  },
  {
    id: '4',
    title: 'Request More Information',
    titleAr: 'طلب معلومات إضافية',
    content:
      'To help resolve your issue faster, could you please provide the following information:\n\n1. Your account email\n2. Screenshot of the error (if any)\n3. Steps to reproduce the issue\n\nThank you!',
    contentAr:
      'للمساعدة على حل مشكلتك بشكل أسرع، هل يمكنك تزويدنا بالمعلومات التالية:\n\n1. البريد الإلكتروني للحساب\n2. لقطة شاشة للخطأ (إن وجد)\n3. خطوات إظهار المشكلة\n\nشكراً لك!',
    category: 'information',
    tags: ['info', 'details', 'request'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/info',
    shortcutAr: '/info_ar',
    usageCount: 67,
  },
  {
    id: '5',
    title: 'Issue Resolved',
    titleAr: 'تم الحل',
    content:
      "Great news! I'm glad we could resolve your issue. Your ticket is now being closed. If you experience any further problems, please don't hesitate to contact us.",
    contentAr:
      'أخبار سارة! سعداء بحل المشكلة. يتم الآن إغلاق تذكرتك. إذا واجهت أي مشكلة لاحقاً، لا تتردد في التواصل معنا.',
    category: 'resolution',
    tags: ['resolved', 'fixed', 'close'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/resolved',
    shortcutAr: '/resolved_ar',
    usageCount: 89,
  },
  {
    id: '6',
    title: 'Brief hold',
    titleAr: 'انتظار قصير',
    content: "Thanks for your patience — I'm looking into this now and will update you shortly.",
    contentAr: 'شكراً لصبرك — أقوم بالتحقق من الأمر الآن وسأحدثك قريباً.',
    category: 'follow-up',
    tags: ['hold', 'wait', 'checking'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/hold',
    shortcutAr: '/hold_ar',
    usageCount: 52,
  },
  {
    id: '7',
    title: 'Apology — inconvenience',
    titleAr: 'اعتذار',
    content:
      "I'm sorry for the inconvenience this has caused. I understand how frustrating that can be, and I'm here to help get this sorted for you.",
    contentAr:
      'أعتذر عن الإزعاج الذي تسبب به ذلك. أتفهم مدى الإحباط، وأنا هنا لمساعدتك في الحل.',
    category: 'apology',
    tags: ['sorry', 'apology', 'empathy'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/sorry',
    shortcutAr: '/sorry_ar',
    usageCount: 41,
  },
  {
    id: '8',
    title: 'Billing — invoice / charge',
    titleAr: 'الفوترة والدفع',
    content:
      "I can help with billing questions. Please share the invoice number or last four digits of the payment method used, and the approximate date of the charge. I'll review it right away.",
    contentAr:
      'يمكنني المساعدة في أسئلة الفوترة. يرجى إرسال رقم الفاتورة أو آخر أربعة أرقام لوسيلة الدفع المستخدمة، وتاريخ الدفع التقريبي. سأراجع الأمر فوراً.',
    category: 'billing',
    tags: ['billing', 'invoice', 'payment', 'charge'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/billing',
    shortcutAr: '/billing_ar',
    usageCount: 28,
  },
  {
    id: '9',
    title: 'Password reset — steps',
    titleAr: 'إعادة تعيين كلمة المرور',
    content:
      'To reset your password:\n1. Open the login page and click "Forgot password".\n2. Enter the email on your account.\n3. Use the secure link we send within 15 minutes.\n\nIf you don\'t see the email, check spam/junk and let me know.',
    contentAr:
      'لإعادة تعيين كلمة المرور:\n1. افتح صفحة تسجيل الدخول واضغط «نسيت كلمة المرور».\n2. أدخل البريد المرتبط بحسابك.\n3. استخدم الرابط الآمن خلال 15 دقيقة.\n\nإذا لم تصلك الرسالة، تحقق من البريد غير الهام وأخبرني.',
    category: 'technical',
    tags: ['password', 'reset', 'login'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/password',
    shortcutAr: '/password_ar',
    usageCount: 73,
  },
  {
    id: '10',
    title: 'Business hours',
    titleAr: 'أوقات العمل',
    content:
      "Our support team is available {{businessHours}}. If you message us outside those hours, we'll reply as soon as we're back online.",
    contentAr:
      'فريق الدعم متاح {{businessHours}}. إذا راسلتنا خارج هذه الأوقات، سنرد بمجرد عودتنا.',
    category: 'information',
    tags: ['hours', 'availability', 'schedule'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/hours',
    shortcutAr: '/hours_ar',
    usageCount: 36,
  },
  {
    id: '11',
    title: 'Follow-up check-in',
    titleAr: 'متابعة',
    content:
      'I wanted to follow up on your case. Are you still experiencing the issue, or is everything working as expected now?',
    contentAr:
      'أردت المتابعة بخصوص حالتك. هل ما زالت المشكلة قائمة أم أن كل شيء يعمل الآن كما يجب؟',
    category: 'follow-up',
    tags: ['follow up', 'check in', 'status'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/followup',
    shortcutAr: '/followup_ar',
    usageCount: 44,
  },
  {
    id: '12',
    title: 'Known service disruption',
    titleAr: 'انقطاع خدمة معروف',
    content:
      "We're aware of a service issue affecting some users. Our team is working on a fix and we'll post updates here. Thank you for your patience.",
    contentAr:
      'نحن على علم بمشكلة تقنية تؤثر على بعض المستخدمين. يعمل فريقنا على إصلاحها وسننشر التحديثات هنا. شكراً لصبرك.',
    category: 'outage',
    tags: ['outage', 'down', 'incident', 'status'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/outage',
    shortcutAr: '/outage_ar',
    usageCount: 19,
  },
  {
    id: '13',
    title: 'Thanks for waiting',
    titleAr: 'شكر على الانتظار',
    content: "Thank you for waiting — I appreciate your patience while I reviewed your account.",
    contentAr: 'شكراً لانتظارك — أقدر صبرك بينما راجعت حسابك.',
    category: 'greeting',
    tags: ['patience', 'thanks', 'wait'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/patience',
    shortcutAr: '/patience_ar',
    usageCount: 31,
  },
  {
    id: '14',
    title: 'Security — verify account',
    titleAr: 'التحقق من الحساب',
    content:
      "To protect your account, please confirm the email address on file (or the phone number ending in ••••). I can't make changes until we verify you're the account owner.",
    contentAr:
      'لحماية حسابك، يرجى تأكيد البريد الإلكتروني المسجل (أو رقم الهاتف المنتهي بـ ••••). لا يمكنني إجراء تغييرات قبل التحقق من أنك صاحب الحساب.',
    category: 'security',
    tags: ['verify', 'security', 'identity'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/verify',
    shortcutAr: '/verify_ar',
    usageCount: 22,
  },
  {
    id: '15',
    title: 'Shipping / order status',
    titleAr: 'حالة الطلب والشحن',
    content:
      "I'd be happy to check your order status. Please send your order number (or the email used at checkout) and I'll look it up.",
    contentAr:
      'يسعدني التحقق من حالة طلبك. أرسل رقم الطلب (أو البريد المستخدم عند الشراء) وسأبحث عنه.',
    category: 'follow-up',
    tags: ['order', 'shipping', 'delivery', 'tracking'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/order',
    shortcutAr: '/order_ar',
    usageCount: 55,
  },
  {
    id: '16',
    title: 'Transfer to specialist',
    titleAr: 'تحويل لأخصائي',
    content:
      "I'm connecting you with a specialist who can handle this in more detail. You'll get a reply shortly — no need to repeat everything; they have your conversation history.",
    contentAr:
      'أقوم بتوصيلك بأخصائي يمكنه التعمق في التفاصيل. ستصلك إجابة قريباً — لا حاجة لتكرار كل شيء؛ لديه سجل المحادثة.',
    category: 'escalation',
    tags: ['transfer', 'specialist', 'handoff'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/transfer',
    shortcutAr: '/transfer_ar',
    usageCount: 17,
  },
  {
    id: '17',
    title: 'Feedback request',
    titleAr: 'طلب ملاحظات',
    content:
      "If you have a moment, we'd love your feedback on how we handled this chat. It helps us improve support for everyone.",
    contentAr:
      'إذا أتيح لك وقت، نقدّر ملاحظاتك حول كيفية تعاملنا مع هذه المحادثة. يساعدنا ذلك على تحسين الدعم للجميع.',
    category: 'closing',
    tags: ['feedback', 'survey', 'csat'],
    isActive: true,
    createdAt: now,
    updatedAt: now,
    shortcut: '/feedback',
    shortcutAr: '/feedback_ar',
    usageCount: 24,
  },
];
